import React from 'react';
import { X } from 'lucide-react';

interface ChatMember {
  id: string;
  name?: string;
}

interface Props {
  visible: boolean;
  members: ChatMember[];
  memberCount: number;
  onClose: () => void;
}

export function EventChatMemberListModal({ visible, members, memberCount, onClose }: Props): React.ReactElement | null {
  if (!visible) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div style={styles.backdrop} onClick={handleBackdropClick}>
      <div style={styles.modal}>
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>Chat Members ({memberCount})</h2>
          <button style={styles.closeButton} onClick={onClose}>
            <X size={24} color="#000" />
          </button>
        </div>
        <div style={styles.memberList}>
          {members.map((member) => (
            <div key={member.id} style={styles.memberItem}>
              <div style={styles.memberAvatar}>
                <span style={styles.memberAvatarText}>
                  {member.name?.[0]?.toUpperCase() || '?'}
                </span>
              </div>
              <span style={styles.memberName}>
                {member.name || `User ${member.id}`}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '400px',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    borderBottom: '1px solid #e0e0e0',
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#000',
    margin: 0,
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
  },
  memberList: {
    flex: 1,
    overflowY: 'auto',
  },
  memberItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 20px',
    minWidth: 0,
  },
  memberAvatar: {
    width: '40px',
    height: '40px',
    borderRadius: '20px',
    backgroundColor: '#3b82f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  memberAvatarText: {
    color: '#fff',
    fontSize: '16px',
    fontWeight: 600,
  },
  memberName: {
    fontSize: '16px',
    color: '#000',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
};
